import { faEdit } from "@fortawesome/pro-regular-svg-icons";

import { IconButton } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type EditSecretButtonProps = {
  secretName: string;
  secretKey: string;
  toggleEditable: (key: string) => void;
};

export const EditSecretButton: React.FC<EditSecretButtonProps> = ({
  secretName,
  secretKey,
  toggleEditable,
}) => (
  <Tooltip placement="right" title={`Edit ${secretName.toLowerCase()}`} asChild>
    <div className="ml-2 flex">
      <IconButton
        dataLoc={`edit-provider-secret-${secretKey}`}
        icon={faEdit}
        size="xs"
        onClick={() => toggleEditable(secretKey)}
      />
    </div>
  </Tooltip>
);
